
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../helpers'
import { LayoutTemplate } from 'lucide-react'
import { useLayout } from '../../core'

import { Navbar } from './Navbar'

export function HeaderWrapper() {
  const { config, classes } = useLayout()


  return (
    <div
      id='kt_app_header'
      className='app-header'
      data-kt-sticky='true'
      data-kt-sticky-activate='{default: true, xl: true}'
      data-kt-sticky-name='app-header-minimize'
      data-kt-sticky-offset='{default: "200px", xl: "0"}'
      data-kt-sticky-animation='false'
    >
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        <div
          className='d-flex align-items-center d-xl-none ms-n2 me-2'
          title='Show sidebar menu'
        >
          <div
            className='w-35px h-35px btn btn-icon btn-active-color-primary'
            id='kt_app_sidebar_mobile_toggle'
          >
            <LayoutTemplate size={24} />
          </div>
          <div className='d-flex flex-grow-1 flex-xl-grow-0 align-items-center'>
            <Link to='/dashboard' className='d-xl-none'>
              <img
                alt='Logo'
                src={toAbsoluteUrl('/tabLogo.png')}
                className='h-30px'
              />
            </Link>
          </div>
        </div>




        <div
          id='kt_app_header_wrapper'
          className='d-flex flex-xl-grow-1 justify-content-between align-items-stretch'
        >

          <div
            key={1}
            className='align-items-stretch app-header-menu app-header-mobile-drawer'
            data-kt-drawer='true'
            data-kt-drawer-name='app-header-menu'
            data-kt-drawer-activate='{default: true, xl: false}'
            data-kt-drawer-overlay='true'
            data-kt-drawer-width='225px'
            data-kt-drawer-direction='end'
            data-kt-drawer-toggle='#kt_app_header_menu_toggle'
            data-kt-swapper='true'
            data-kt-swapper-mode="{default: 'append', xl: 'prepend'}"
            data-kt-swapper-parent="{default: '#kt_app_body', xl: '#kt_app_header_wrapper'}"
          >
          </div>
          <Navbar />
        </div>
      </div>
    </div>
  )
}
